<template>
  <DashboardPanelTemplate :panelSize="panelSize" :panelFocus="panelFocus" :loading="loading">
    <div class="panel-wrapper">
      <div class="panel-header">
        {{ $t("Header") }}
      </div>
      <div class="panel-row" @click="handleClickOfficeHours">
        <div class="img-base">
          <img class="row-icon" :src="require('../assets/images/OfficeHoursIcon.png')" alt="Office Hours Icon">
        </div>
        <div class="text-colum">
          <div class="text-header">
            {{ $t("OfficeHoursHeader") }}
          </div>
          <div class="text-description">
            {{ $t("OfficeHoursDescription") }}
          </div>
        </div>
        <div class="img-base">
          <img :src="require('../assets/images/ArrowNext.png')" alt="Arrow next">
        </div>
      </div>
      <div class="divider" />
      <div class="panel-row" @click="handleClickPricing">
        <div class="img-base">
          <img class="row-icon" :src="require('../assets/images/PricingQuestionIcon.png')" alt="Pricing Icon">
        </div>
        <div class="text-colum">
          <div class="text-header">
            {{ $t("PricingHeader") }}
          </div>
          <div class="text-description">
            {{ $t("PricingDescription") }}
          </div>
        </div>
        <div class="img-base">
          <img :src="require('../assets/images/ArrowNext.png')" alt="Arrow next">
        </div>
      </div>
      <div class="divider" />
      <div class="panel-row" @click="handleClickHelpCenter">
        <div class="img-base">
          <img class="row-icon" :src="require('../assets/images/HelpCenterIcon.png')" alt="Help Center Icon">
        </div>
        <div class="text-colum">
          <div class="text-header">
            {{ $t("HelpCenterHeader") }}
          </div>
          <div class="text-description">
            {{ $t("HelpCenterDescription") }}
          </div>
        </div>
        <div class="img-base">
          <img :src="require('../assets/images/ArrowNext.png')" alt="Arrow next">
        </div>
      </div>
    </div>
  </DashboardPanelTemplate>
</template>
<script>
import DashboardPanelTemplate from '../../layouts/DashboardPanelTemplate'
import ShipbobAppSettings from '../../../appSettings/appSetting'

export default {
  name: 'GetStartedToolsPanel',
  components: {
    DashboardPanelTemplate
  },
  props: {
    panelSize: {
      type: String,
      required: true
    },
    panelFocus: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    showCostCalculatorModal: {
      type: Function,
      default: () => null
    }
  },
  computed: {
    ShipbobOfficeHoursUrl () {
      return ShipbobAppSettings.OnboardingDashboardConfig.OfficeHoursLink
    },
    ShipbobHelpCenterUrl () {
      return ShipbobAppSettings.OnboardingDashboardConfig.HelpCenterLink
    }
  },
  methods: {
    handleClickOfficeHours () {
      window.open(this.ShipbobOfficeHoursUrl, '_blank')
    },
    handleClickPricing () {
      this.showCostCalculatorModal()
    },
    handleClickHelpCenter () {
      window.open(this.ShipbobHelpCenterUrl, '_blank')
    }
  },
  i18n: {
    messages: {
      'en-US': {
        Header: 'Tools to Help You Get Started',
        OfficeHoursHeader: 'Need help? Join our office hours.',
        OfficeHoursDescription: 'If you need more guidance, join our office hours with our onboarding gurus.',
        PricingHeader: 'Questions about pricing?',
        PricingDescription: 'Calculate how much it costs to pick, pack, and ship orders to your customers.',
        HelpCenterHeader: 'Visit the Help Center.',
        HelpCenterDescription: 'Visit our Help Center for articles and tutorials on how to get started.'
      }
    }
  }
}

</script>
<style scoped lang='scss'>
@import '../../../../assets/scss/shipbob-custom/components/dashboard/_setup-panel-tools.scss';
</style>
